export const optionsCompany = [
    {id: 1, name: "Rosinox - Grandes cuisines"},
    {id: 2, name: "Friginox - Le froid professionnel"}
]
